import React from "react";
import "../Roadmap/Roadmap.css";
import { Container } from "react-bootstrap";
import Accordian from "../Accordian/Accordian";

export default function Faq() {
  return (
    // Sharing the same styles as ROADMAP component
    <section id="faq">
      <Container>
        <div className="content">
          <h4 className="sm-title">Projetos em Curso</h4>
          <div className="top-text">
            <h1 className="lg-title">Projetos e Financiamento</h1>
            <h2 className="desc">
            Centramo-nos na criação de projetos inovadores e patenteados no setor da Agricultura, reforçando a confiança e a credibilidade ao exibir os nossos projetos e os logótipos das distinções conquistadas.
            </h2>
          </div>
        </div>
      </Container>
      <div className="customContainer">
        <Accordian theme="dark" />
      </div>
    </section>
  );
}
